<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container" v-loading="loading">
        <div v-if="goods" class="detail-wrap">
          <div class="left">
            <img :src="goods.thumbnail || goods.image" class="main-img" />
          </div>
          <div class="right">
            <div class="goods-name">{{ goods.name }}</div>
            <div class="point-row">
              <span class="point-icon">⭐</span>
              <span class="point-val">{{ exchangePoint }}</span>
              <span class="point-label"> {{ $t('message.home.point') }}</span>
            </div>
            <div class="stock-row">{{ $t('message.home.stock') }}：{{ goods.stock || goods.stockQuantity }}</div>
            <div class="spec-row" v-if="goods.specifications">
              <span>{{ $t('message.home.spec') }}：{{ goods.specifications }}</span>
            </div>
            <div class="action-row">
              <el-input-number v-model="quantity" :min="1" :max="goods.stockQuantity || goods.stock || 99" size="medium" />
              <el-button type="warning" size="medium" :disabled="!(goods.stock || goods.stockQuantity)" @click="handleExchange">
                {{ $t('message.home.exchangeNow') }}
              </el-button>
            </div>
            <div class="tips">{{ $t('message.home.currentPoint') }}：{{ memberPoint }}</div>
          </div>
        </div>
        <el-empty v-if="!goods && !loading" />
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { exchange_list } from '@/api/goods/goods'
import { load_member } from '@/api/upms/profile'
import { isShopLoggedIn } from '@/util/shopAuth'

export default {
  name: 'PointGoodsDetail',
  data() {
    return { loading: false, goods: null, skuId: null, exchangePoint: 0, quantity: 1, memberPoint: 0 }
  },
  created() {
    this.exchangePoint = Number(this.$route.query.exchangePoint) || 0
    this.loadData()
    this.loadMemberPoint()
  },
  methods: {
    loadData() {
      const id = this.$route.params.id || this.$route.query.id
      if (!id) return
      this.loading = true
      exchange_list({ pageNumber: 1, pageSize: 100 }).then(r => {
        const data = r.data?.data
        const arr = Array.isArray(data) ? data : (data?.content || [])
        const item = arr.find(it => it.goods && String(it.goods.id) === String(id))
        if (item) {
          this.skuId = item.id || null
          this.goods = { ...item.goods, stock: item.availableStock != null ? item.availableStock : item.stock }
          if (item.exchangePoint != null) this.exchangePoint = item.exchangePoint
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    loadMemberPoint() {
      if (!isShopLoggedIn(this)) {
        this.memberPoint = 0
        return
      }
      load_member().then(r => { this.memberPoint = r.data?.data?.member?.point ?? 0 }).catch(() => {})
    },
    handleExchange() {
      if (!isShopLoggedIn(this)) {
        this.$router.push({ path: '/login', query: { redirect: this.$route.fullPath } })
        return
      }
      if (this.memberPoint < this.exchangePoint * this.quantity) {
        this.$message.warning(this.$t('message.home.pointNotEnough'))
        return
      }
      if (!this.skuId) {
        this.$message.warning(this.$t('message.home.noData') || 'SKU missing')
        return
      }
      this.$router.push({
        path: '/settlement',
        query: {
          skuId: this.skuId,
          goodsId: this.goods.id,
          quantity: this.quantity,
          type: 'EXCHANGE'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 40px 0; }
.detail-wrap { display: flex; gap: 48px; background: #fff; padding: 32px; border-radius: 8px; }
.left { flex-shrink: 0; }
.main-img { width: 360px; height: 360px; object-fit: cover; border-radius: 8px; }
.right { flex: 1; }
.goods-name { font-size: 20px; font-weight: bold; color: #303133; margin-bottom: 20px; }
.point-row { display: flex; align-items: center; margin-bottom: 16px; }
.point-icon { font-size: 22px; margin-right: 6px; }
.point-val { font-size: 32px; font-weight: bold; color: #e6a23c; }
.point-label { font-size: 16px; color: #909399; margin-left: 4px; }
.stock-row, .spec-row { font-size: 14px; color: #606266; margin-bottom: 12px; }
.action-row { display: flex; gap: 16px; align-items: center; margin: 24px 0; }
.tips { font-size: 13px; color: #909399; }
</style>
